import dayjs from 'dayjs'
import { useEffect, useState } from 'react'

import { AppCheckboxBadged } from '../../../checkbox'
import { DateRange } from '../Calendar.types'

const DAYS_QUICK_FILTERS = [
  {
    label: '30 дней',
    value: 30
  },
  {
    label: '90 дней',
    value: 90
  },
  {
    label: 'Год',
    value: 365
  }
]

const MONTHS_QUICK_FILTERS = [
  {
    label: '3 месяца',
    value: 90
  },
  {
    label: '6 месяцев',
    value: 180
  },
  {
    label: 'Год',
    value: 365
  }
]

type Props = {
  range?: DateRange
  setRange: (range?: DateRange) => void
  mode?: 'day' | 'month'
}

export const CalendarQuickFilters = ({
  mode = 'day',
  range = { from: undefined, to: undefined },
  setRange
}: Props) => {
  const [localRange, setLocalRange] = useState(range)

  const currentFilters =
    mode === 'day' ? DAYS_QUICK_FILTERS : MONTHS_QUICK_FILTERS

  useEffect(() => {
    setLocalRange(range)
  }, [range])

  const isFilterActive = (filterValue: number) => {
    if (!localRange?.from || !localRange?.to) {
      return false
    }

    return (
      dayjs(localRange.from).isSame(
        dayjs().subtract(filterValue - 1, 'day'),
        'day'
      ) && dayjs(localRange.to).isSame(dayjs(), 'day')
    )
  }

  const onQuickFilterClick = (filterValue: number) => {
    const currentDate = new Date()

    setRange({
      from: dayjs()
        .subtract(filterValue - 1, 'day')
        .toDate(),
      to: currentDate
    })
    setLocalRange({
      from: dayjs()
        .subtract(filterValue - 1, 'day')
        .toDate(),
      to: currentDate
    })
  }

  const resetPeriod = () => {
    setRange(undefined)
    setLocalRange({ from: undefined, to: undefined })
  }

  return (
    <div className="mt-8 flex flex-wrap gap-8">
      {currentFilters.map(filter => (
        <AppCheckboxBadged
          key={filter.value}
          checked={isFilterActive(filter.value)}
          onChange={event => {
            event.preventDefault()
            onQuickFilterClick(filter.value)
          }}
          onIconClick={resetPeriod}
          label={filter.label}
          dataTestId={`quick-period-${filter.value}-id`}
          closable
        />
      ))}
    </div>
  )
}
